
import {ServerApi} from '../../h5_src/network/server-api';

export class ServerBizApi extends ServerApi {

    public static async send(uri, data) {
        this.baseUrl = this.getPrefix();
        return await this.syncPost(uri, data);
    }
    public static getPrefix() {
        return  '/server/api-v1.0/';
    }

}


export class ServerProdApi extends ServerApi {

    public static async send(uri, data) {
        this.baseUrl = this.getPrefix();
        let resp = await this.syncPost(uri, data);
        return resp;
    }
    public static getPrefix() {
        return  '/dataone-auth/';
    }
}

export class ServerDistApi1 extends ServerApi {

    public static async send(uri, data) {
        this.baseUrl = this.getPrefix();
        let resp = await this.syncPost(uri, data);
        return resp;
    }
    public static async get(uri, data, opt = {}) {
        this.baseUrl = this.getPrefix();
        let resp = await this.asyncGet(uri, data, opt);
        return resp;
    }
    public static getPrefix() {
        return  '/g-api';
    }
}

//登录
export class ServerProdApidl extends ServerApi {

    public static async send(uri, data) {
        this.baseUrl = this.getPrefix();
        let resp = await this.syncPost(uri, data);
        return resp;
    }

    public static async Get(uri, data){
        this.baseUrl = this.getPrefix();
        let resp = await this.asyncGet(uri, data);
        return resp;
    }
    public static getPrefix() {
        return  '/dataone-auth/';
    }

}
// 商品管理模块
export class ServerDistApi extends ServerApi {
    //通用上传
    public static async send(uri, data) {
        this.baseUrl = this.getPrefix();
        let resp = await this.syncPost(uri, data);
        return resp;
    }
    //上传图片:不加前缀
    public static async sendImgPost(uri, data){
        this.baseUrl = '';
        let resp = await this.syncImgPost(uri, data, false);
        return resp;
    }

    //测试需删除
    public static async testSendPost(uri, data){
        this.baseUrl = '';
        let resp = await this.syncImgPost(uri, data, true);
        return resp;
    }
    //测试需删除
    public static async testGetPost(uri, data){
        this.baseUrl = '';
        let resp = await this.asyncTestGet(uri, data, true);
        return resp;
    }
    //下载:不加前缀
    public static async sendDownloadPost(uri, data, isBlob){
        this.baseUrl = '';
        let resp = await this.syncImgPost(uri, data, isBlob);
        return resp;
    }

    //下载:不加前缀
    public static async downloadTemplate(uri){
        this.baseUrl = '';
        let resp = await this.downFileTemplate(uri);
        return resp;
    }

    public static async get(uri, data, opt = {}) {
        this.baseUrl = this.getPrefix();
        let resp = await this.asyncGet(uri, data, opt);
        return resp;
    }

    public static getPrefix() {
        return '/data-dist/api/dist';
    }
}
//价格管理
export class ServerPriceApi extends ServerApi {
    //不添加前缀
    public static async sendNoBase(uri, data) {
        this.baseUrl = '';
        let resp = await this.syncPost(uri, data);
        return resp;
    }
    //不添加前缀
    public static async getNoBase(uri, data) {
        this.baseUrl = '';
        let resp = await this.asyncGet(uri, data);
        return resp;
    }
}
//物流调度模块
export class ServerNoDistApi extends ServerApi {
    public static async send(uri, data) {
        this.baseUrl = this.getPrefix();
        let resp = await this.syncPost(uri, data);
        return resp;
    }
    public static async get(uri, data) {
        this.baseUrl = this.getPrefix();
        let resp = await this.asyncGet(uri, data);
        return resp;
    }

    public static getPrefix() {
        return '/data-dist/api';
    }
}

//客户任务管理
export class ServerTaskApi extends ServerApi {
    public static async send(uri, data) {
        this.baseUrl = this.getPrefix();
        let resp = await this.syncPost(uri, data);
        return resp;
    }
    public static async get(uri, data) {
        this.baseUrl = this.getPrefix();
        let resp = await this.asyncGet(uri, data);
        return resp;
    }

    public static getPrefix() {
        return '/data-dist';
    }
}
